import { Record, fromJS, List } from 'immutable'

import { NotificationTypes } from 'store/entities/identity/records'

const ChangesObjectRecord = Record({
  email: null,
  date: null,
})

class ChangesObject extends ChangesObjectRecord {}

const UserChangesRecord = Record({
  phone: new ChangesObject(),
  notificationType: new ChangesObject(),
  resendSelectNewProTrack: new ChangesObject(),
  resendInvitation: new ChangesObject(),
})

class UserChanges extends UserChangesRecord {}

export const UserRecord = Record({
  id: null,
  email: null,
  firstName: null,
  lastName: null,
  avatar: null,
  roles: fromJS([]),
  completedCount: 0,
  resendInvitePending: false,
  invitationHasBeenSent: false,
  userProTrackLevelId: null,
  isUserProtrackLevelsExist: false,
  activated: false,
  organizationId: null,
  invitationAccepted: false,
  currentProTrackName: null,
  currentProTrackId: null,
  levelFinished: null,
  levelStopped: null,
  phone: null,
  phoneISO: null,
  teams: List(),
  notificationType: new NotificationTypes(),
  userChanges: new UserChanges(),
  invitationDelayTime: null,
  timezone: null,
  invitedByUser: null,
  invitedVia: null,
})

export class User extends UserRecord {}
